import { ApiService } from '../apiService';

// The backend picks the language from the `Language` request header
// (see apps.core.utils.get_request_language).
const langConfig = (language) => ({ headers: { Language: language } });

class Company extends ApiService {
  getPrivacyPolicy(language = 'hy') {
    return this.get('company/privacy-policy/', {}, langConfig(language));
  }

  getTermsOfUse(language = 'hy') {
    return this.get('company/terms-of-use/', {}, langConfig(language));
  }

  getAccountDeletion(language = 'hy') {
    return this.get('company/account-deletion/', {}, langConfig(language));
  }
}

export default new Company();
